"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FacebookIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Facebook_svg_1 = __importDefault(require("./Facebook.svg"));
/**
 * Facebook icon.
 * figma link - https://www.figma.com/file/M9VCQnWUmAbbRy9VXOtlwO/Atomic-Icons?node-id=916%3A916
 */
function FacebookIcon() {
    return (0, jsx_runtime_1.jsx)(Facebook_svg_1.default, {});
}
exports.FacebookIcon = FacebookIcon;
//# sourceMappingURL=FacebookIcon.js.map